import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KeywordTypeService } from '@services/keywordType.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-keywordtype',
  templateUrl: './keywordtype.component.html',
  styleUrls: ['./keywordtype.component.css']
})
export class KeywordtypeComponent implements OnInit {

  definitionForm:FormGroup;
  submitted=false;
  @Input() data:any;
  @Input() courseid:any;
  constructor(
    private formBuilder:FormBuilder,
    private activeModal:NgbActiveModal,
    private languageService:KeywordTypeService,
    private toastrService:ToastrService,
    ) { }

  ngOnInit() {
    this.definitionForm=this.formBuilder.group({
      'name':['',Validators.required],
      'courseId':[this.courseid,Validators.required],
      'code':[this.courseid,Validators.required],
      'shortName':[this.courseid],
     
    });

    if(this.data){

       this.definitionForm.get("name").patchValue(this.data.name);
       this.definitionForm.get("courseId").patchValue(this.data.courseId);
       this.definitionForm.get("code").patchValue(this.data.code);
       this.definitionForm.get("shortName").patchValue(this.data.shortName);
       
       
    }
    
  }



  save(){

    if(!this.definitionForm.valid){
      this.definitionForm.markAllAsTouched();
      this.toastrService.clear();
      this.toastrService.warning("Fill the required fields","Warning");
      return;
    }
    this.submitted=true;

    if(this.data){

      this.languageService.update(this.data.id,this.definitionForm.value).subscribe(res=>{

        this.toastrService.clear();
        this.toastrService.success("Update success","Update success");
        this.definitionForm.reset();
        this.submitted=false;
      },err=>{
        this.submitted=false;
        this.toastrService.clear();
        this.toastrService.error("Exception","Exception");
      });


    }else{
      this.languageService.add(this.definitionForm.value).subscribe(res=>{

        this.toastrService.clear();
        this.toastrService.success("Success","Success");
        this.definitionForm.reset();
        this.submitted=false;
      },err=>{
        this.submitted=false;
        this.toastrService.clear();
        this.toastrService.error("Exception","Exception");
      });
    }



  }

  close(){
    this.activeModal.close();
  }






}
